import { RegisterTerminalModalJustifiSteps, RegisterTerminalModalStripeSteps } from './hooks';
import { JustifiAllSteps } from './justifi-steps';
import { StripeAllSteps } from './stripe-steps';
import { RegisterTerminalModalType, StepperProps } from './types';

type RegisterTerminalModalAllStepsProps = {
  goToBigBang?: () => void; // handler that takes you to the start of the flow from where this flow starts
  goToStep?: (step: RegisterTerminalModalJustifiSteps | RegisterTerminalModalStripeSteps) => void; // handler that takes you to the step in the flow
  goBack?: () => void; // handler that takes you back to the previous step
  onComplete: () => void; // handler that takes you to the next step in the flow
  onRegisterTerminal: () => void; // handler that takes you to the next step in the flow
  Stepper: React.FC<StepperProps>; // component that renders the stepper
  locationId?: string;
  stripeLocationId?: string;
  type: RegisterTerminalModalType; // type of terminal, either stripe or justifi
};
export const RegisterTerminalModalAllSteps = ({
  goToBigBang,
  goToStep,
  goBack,
  onComplete,
  onRegisterTerminal,
  Stepper,
  locationId,
  stripeLocationId,
  type,
}: RegisterTerminalModalAllStepsProps) => {
  if (type === RegisterTerminalModalType.Justifi) {
    return (
      <JustifiAllSteps
        goToBigBang={goToBigBang}
        goToStep={goToStep}
        goBack={goBack}
        onComplete={onComplete}
        onRegisterTerminal={onRegisterTerminal}
        Stepper={Stepper}
        locationId={locationId}
      />
    );
  }

  return (
    <StripeAllSteps
      goToBigBang={goToBigBang}
      goToStep={goToStep}
      goBack={goBack}
      onComplete={onComplete}
      onRegisterTerminal={onRegisterTerminal}
      Stepper={Stepper}
      locationId={locationId}
      stripeLocationId={stripeLocationId}
    />
  );
};

RegisterTerminalModalAllSteps.displayName = 'RegisterTerminalStep';
